import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  ExpandableFilter,
  ListActions,
  Pagesection,
  ListByYear,
  SearchBar,
  Sprite,
  useQueryParam,
} from '@ktag/styleguide/dist/react';
import { ISSUE_FILTER_TYPES } from 'utils/getIssueType';
import useIssues, { SORT_OPTIONS } from './useIssues';
import ArchiveIssueTeaser from './ArchiveIssueTeaser';

const Issues = () => {
  const { t } = useTranslation('wap');
  const [typesParams, setTypesParams]: [string, (type: string) => void] = useQueryParam(
    'types',
    '',
  );

  const initialTypes = typesParams ? typesParams.split(',') : [];

  const ISSUE_FILTERS: { label: string; value: string }[] = [
    {
      label: t('issue_filter_poll'),
      value: ISSUE_FILTER_TYPES.poll,
    },
    {
      label: t('issue_filter_national_council'),
      value: ISSUE_FILTER_TYPES.nationalCouncil,
    },
    {
      label: t('issue_filter_grossrat'),
      value: ISSUE_FILTER_TYPES.grossRat,
    },
    {
      label: t('issue_filter_council_of_states'),
      value: ISSUE_FILTER_TYPES.councilOfStates,
    },

    {
      label: t('issue_filter_government_council'),
      value: ISSUE_FILTER_TYPES.governmentCouncil,
    },
    {
      label: t('issue_filter_local_election'),
      value: ISSUE_FILTER_TYPES.localElection,
    },
  ];

  const {
    sort,
    hasMore,
    onLoadMore,
    term,
    setTerm,
    numberOfResults,
    setSort,
    displayedIssues,
  } = useIssues(initialTypes);

  const onTypeChange = (types: string[]) => {
    const selectedTypesJoined = types.join(',');
    setTypesParams(selectedTypesJoined);
  };

  return (
    <div className="wap__archive-issues-wrapper">
      <Pagesection>
        <SearchBar
          search={term}
          setSearch={setTerm}
          placeholder={t('search_placeholder')}
        />
        <ExpandableFilter
          label={t('issues_filter')}
          name={t('issues_filter')}
          type="multiselect"
          options={ISSUE_FILTERS}
          asChips
          numberOfResults={0}
          onChange={onTypeChange}
          initialValue={initialTypes}
        />
        <ListActions
          sortOptions={SORT_OPTIONS}
          sort={sort}
          setSort={setSort}
          numberOfResults={numberOfResults}
        />
      </Pagesection>
      <Pagesection type="medium" additionalClassNames="wap__archive-issues">
        <ListByYear
          dateKey="date"
          sort={{ property: 'date', method: sort.value.direction }}
          headingLevel={2}
          items={displayedIssues}
          renderListItem={(issue) => (
            <li className="issueteaser" key={issue.id}>
              <ArchiveIssueTeaser issue={issue} />
            </li>
          )}
        />
        {hasMore && (
          <div className="wap__archive-issues-load-more-wrapper">
            <button
              className="wap__archive-issues-load-more"
              type="button"
              onClick={onLoadMore}
            >
              {t('load_more')}
              <Sprite id="chevron" />
            </button>
          </div>
        )}
      </Pagesection>
    </div>
  );
};

export default Issues;
